<app-anonymous-page-layout>
  <app-card>
    <app-page-title
      [title]="(success ? 'PAGE.EMAIL_VERIFICATION_RESULT.TITLE_SUCCESS' : 'PAGE.EMAIL_VERIFICATION_RESULT.TITLE_FAILURE') | translate"
      style="--page-title-padding-bottom: var(--size-xl)"
    ></app-page-title>

    <div class="content" style="text-align: center">
      <ng-container *ngIf="success">
        <div class="content success">
          <app-icon name="check" style="--icon-size: 48px; color: var(--color-success)"></app-icon>
          <p>{{ 'PAGE.EMAIL_VERIFICATION_RESULT.SUCCESS_MESSAGE' | translate }}</p>
        </div>
      </ng-container>

      <ng-container *ngIf="!success">
        <div class="content error">
          <app-icon name="x-close" style="--icon-size: 48px; color: var(--color-error)"></app-icon>
          <p>{{ 'PAGE.EMAIL_VERIFICATION_RESULT.ERROR_MESSAGE' | translate }}</p>
          <p *ngIf="error" class="error-details">{{ error }}</p>
        </div>
      </ng-container>

      <div class="actions" style="margin-top: var(--size-xl)">
        <app-button
          [label]="'PAGE.EMAIL_VERIFICATION_RESULT.BUTTON_TO_LOGIN' | translate"
          (click)="navigateToLogin()"
          [stretched]="true"
        ></app-button>
      </div>
    </div>
  </app-card>
</app-anonymous-page-layout>
